import React from "react";
import "../styles/accordian.css";
import "../styles/agentTableResponsive.css";

const AgentTable = ({ columns, rows, eventKey }) => {

    return (
        <>
           
            <div className="tab-pane fade show" id="nav-Paper" role="tabpanel"
                aria-label="Agent Information">
                <div id="carouselExampleIndicators" className="carousel slide">
                    <div className="carousel-inner ps-xl-4 mt-4">
                        <div className="carousel-item active">
                            <div
                                className="col-xl-12 d-xl-flex d-md-flex d-sm-flex d-block mb-3 px-2">
                                <div tabIndex={0}
                                    className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                    <label className="label-heading">{columns?.overview_agent_name}</label>
                                    <label className="label-name fw-medium">{rows?.name}</label>
                                </div>
                                <div tabIndex={0}
                                    className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                    <label className="label-heading">{columns?.overview_agent_email}</label>
                                    <label className="label-name fw-medium">
                                        {rows?.email}
                                    </label>
                                </div>
                                <div tabIndex={0}
                                    className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                    <label className="label-heading">
                                        {columns?.overview_agent_phone}
                                    </label>
                                    <label className="label-name fw-medium">
                                    {(rows?.phone !== 'N/A') && '+1 '} {rows?.phone}
                                    </label>
                                </div>
                            </div>
                            <div className="col-xl-12 d-xl-flex d-md-flex d-sm-flex d-block mb-3 px-2">
                                <div tabIndex={0}
                                    className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                    <label className="label-heading">
                                        {columns?.overview_agent_type}
                                    </label>
                                    <label className="label-name fw-medium">
                                        {rows?.type}
                                    </label>
                                </div>
                                <div tabIndex={0}
                                    className="col-xl-8 col-md-8 col-md-8 col-sm-8 col-12 labels">
                                    <label className="label-heading">
                                        {columns?.overview_agent_address}
                                    </label>
                                    <label className="label-name fw-medium">
                                        {rows?.address}
                                    </label>
                                </div>
                            </div>
                            <div className="col-xl-12 d-xl-flex d-md-flex d-sm-flex d-block mb-3 px-2">
                                <div tabIndex={0}
                                    className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                    <label className="label-heading">{columns?.overview_agent_fax}</label>
                                    <label className="label-name fw-medium">
                                        {(rows?.fax !== 'N/A') ? `+1 ` : ''} {rows?.fax}
                                    </label>
                                </div>

                                <div tabIndex={0}
                                    className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                    <label className="label-heading">
                                        {columns?.overview_agent_compnay_name}
                                    </label>
                                    <label className="label-name fw-medium">
                                        {rows?.company}
                                    </label>
                                </div>
                                {rows?.npn && (
                                    <div tabIndex={0}
                                        className="col-xl-4 col-md-4 col-md-4 col-sm-4 col-12 labels">
                                        <label className="label-heading">
                                        {columns?.overview_agent_npn}
                                        </label>
                                        <label className="label-name fw-medium">
                                        {rows?.npn}
                                        </label>
                                    </div>
                                )}
                            </div>

                        </div>

                    </div>                   

                </div>

            </div>
        </>
    )
}
export default AgentTable;